/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import VerifiedCustomersTable from './VerifiedCustomersTable';
import { displaySource, displayAccountType } from '../../../../../../utils/wificall/helpers';

const VerifiedCustomersBody = ({
  filterBySource,
  filterByAccountType,
  customers,
  isLoading,
  filteredPages,
  source,
  handleSource,
  handlePlanType,
  planType,
}) => {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [recordsPerPage, setRecordsPerPage] = useState('');
  const [category, setCategory] = useState('');
  const [allPages] = useState(1);

  const sourceTypeData = {
    from,
    to,
    isVerified: true,
  };
  const accountTypeData = {
    from,
    to,
    planType,
    isVerified: true,
  };

  const searchCustomers = (e) => {
    e.preventDefault();
    if (category === 'sourceType' && source !== 'all')
      return filterBySource(source, sourceTypeData, allPages, recordsPerPage);
    if (category === 'sourceType' && source === 'all')
      return filterByAccountType(sourceTypeData, allPages, recordsPerPage);
    return filterByAccountType(accountTypeData, allPages, recordsPerPage);
  };

  const filterPageClick = async (data) => {
    const selectedPage = data.selected + 1;
    if (category === 'sourceType' && source !== 'all')
      return filterBySource(source, sourceTypeData, selectedPage, recordsPerPage);
    if (category === 'sourceType' && source === 'all')
      return filterByAccountType(sourceTypeData, selectedPage, recordsPerPage);
    return filterByAccountType(accountTypeData, selectedPage, recordsPerPage);
  };

  const validateForm = () => {
    if (category === 'sourceType') return source.length !== 2 && from.length > 0 && to.length > 0;
    return planType.length > 2 && from.length > 0 && to.length > 0;
  };

  return (
    <>
      <div className="col-12 my-2">
        <form className="form-inline pl-4" onSubmit={searchCustomers}>
          <div className="form-group mr-2">
            <small className="ml-2 mr-1">Filter By: </small>
            <select
              className="form-control mr-2"
              defaultValue="DEFAULT"
              name="category"
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="DEFAULT" disabled>
                -- Category --
              </option>
              <option value="sourceType">Source</option>
              <option value="accountType">Account Type</option>
            </select>
          </div>
          <div className="form-group mr-2">
            {category === 'sourceType'
              ? displaySource(handleSource)
              : category === 'accountType'
              ? displayAccountType(handlePlanType)
              : null}
          </div>
          <div className="form-group mr-2">
            <small className="mr-1">From: </small>
            <input
              type="date"
              className="form-control"
              name="from"
              onChange={(e) => setFrom(e.target.value)}
              value={from}
            />
          </div>
          <div className="form-group mr-2">
            <small className="mr-1">To: </small>
            <input type="date" className="form-control" name="to" onChange={(e) => setTo(e.target.value)} value={to} />
          </div>
          <div className="form-group mr-2">
            <input
              type="number"
              min="1"
              placeholder="Per Page"
              className="form-control w-50 p-2"
              name="recordsPerPage"
              onChange={(e) => setRecordsPerPage(e.target.value)}
              value={recordsPerPage}
            />
          </div>
          {isLoading ? (
            <button type="button" className="btn btn-green ml-3" disabled>
              Fetching...
            </button>
          ) : (
            <button type="submit" className="btn btn-green ml-3" disabled={!validateForm()}>
              Submit
            </button>
          )}
        </form>
        <VerifiedCustomersTable customers={customers} load={isLoading} />

        <div className="px-3">
          {filteredPages > 1 ? (
            <ReactPaginate
              previousLabel="previous"
              nextLabel="next"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={filteredPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={filterPageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

VerifiedCustomersBody.propTypes = {
  filterBySource: PropTypes.func.isRequired,
  filterByAccountType: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  customers: PropTypes.arrayOf.isRequired,
  filteredPages: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  planType: PropTypes.string.isRequired,
  handleSource: PropTypes.func.isRequired,
  handlePlanType: PropTypes.func.isRequired,
};

export default VerifiedCustomersBody;
